import React from 'react'

import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import OptionsForm from './options/OptionsForm'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../components/pdf/Preview'

const PageContent = () => {
  return (
    <PdfOptionsFormHandler>
      <FlexGrid align="stretch">
        <FlexCol flex={3} invisibleOn="mdd">
          <Preview>
            <PdfDocument />
          </Preview>
        </FlexCol>

        <FlexCol flex={1}>
          <OptionsForm />
        </FlexCol>
      </FlexGrid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
